<template>
  <div class="ticket-romancecar mb-foot-1button">
    <!-- 変更の場合 -->
    <h1 v-if="method == 'change'" class="heading center">変更完了</h1>
    <!-- 予約の場合 -->
    <h1 v-else-if="myLimitedExpressTicket.ticketing_status == '01'" class="heading center">
      予約完了
    </h1>
    <!-- 引換えの場合 -->
    <h1 v-else-if="isUseCoupon" class="heading center">引き換え完了</h1>
    <!-- 上記以外(購入) -->
    <h1 v-else class="heading center">購入完了</h1>

    <hr />

    <!-- 予約変更の場合:「変更完了」Green -->
    <div v-if="method == 'change' && myLimitedExpressTicket.ticketing_status == '01'
      " class="alert-erea reserved">
      <div class="alert">予約の変更が完了しました</div>
    </div>

    <!-- 予約の場合:「予約完了」Green -->
    <div v-else-if="myLimitedExpressTicket.ticketing_status == '01'" class="alert-erea reserved">
      <div class="alert">予約が完了しました</div>
    </div>

    <!-- 引換えの場合:「引換え完了」or「特急券の変更が完了しました」 Blue -->
    <div v-else-if="isUseCoupon" class="alert-erea buy">
      <div v-if="method == 'change'" class="alert">
        特急券の変更が完了しました
      </div>
      <div v-else class="alert">引き換えが完了しました</div>
    </div>

    <!-- 購入変更の場合:「変更完了」Blue -->
    <div v-else-if="method == 'change' && myLimitedExpressTicket.ticketing_status == '02'
      " class="alert-erea buy">
      <div class="alert">
        {{
          myLimitedExpressTicket.app_code == "DP"
          ? "変更が完了しました"
          : "特急券の変更が完了しました"
        }}
      </div>
    </div>

    <!-- 購入の場合:「購入完了」Blue -->
    <div v-else class="alert-erea buy">
      <div class="alert">購入が完了しました</div>
    </div>

    <!-- 購入期限の注意書き(予約のみ) -->
    <StorePurchaseLimitCaution v-if="myLimitedExpressTicket.ticketing_status == '01'"
      :limit="displayMfittDateTime(myLimitedExpressTicket.auto_canceled_at)" />

    <div class="content-block">
      <div class="block">
        <!-- 乗車日 -->
        <ViBoardingDate :boardingDate="myLimitedExpressTicket.boarding_date" />

        <!-- 列車名 -->
        <ViTrainInfo :name="myLimitedExpressTicket.train.name"
          :carsFormationName="myLimitedExpressTicket.train.cars_formation.name" />

        <!-- 区間 -->
        <ViStationSection :from="myLimitedExpressTicket.from_station.name" :to="myLimitedExpressTicket.to_station.name" />

        <!-- 時間 -->
        <ViDepartureAndArrival :departure="myLimitedExpressTicket.departure_at"
          :arrival="myLimitedExpressTicket.arrival_at" />

        <!-- 座席種類 -->
        <StoreSeatType :selectedSeats="myLimitedExpressTicket.seats"
          :selectedExclusiveCars="myLimitedExpressTicket.train.cars_formation.cars" />

        <!-- 座席 -->
        <StoreSeats :seats="myLimitedExpressTicket.seats" :isPurchased="myLimitedExpressTicket.ticketing_status == '02' ||
          myLimitedExpressTicket.ticketing_status == '04'
          " />

        <!-- 購入金額(購入) 購入変更の時は表示しない -->
        <StoreTicketPrice v-if="!isUseCoupon &&
          method == 'booking' &&
          myLimitedExpressTicket.ticketing_status == '02'
          " :totalPrice="myLimitedExpressTicket.limited_express_ticket_price" />
      </div>
    </div>

    <div class="caution-block">
      <!-- 購入時のみ(引換券使用時は非表示) -->
      <div v-if="myLimitedExpressTicket.ticketing_status == '02' && !isUseCoupon" class="warning-block">
        ご乗車の際は、別途乗車券・フリーパスが必要です。
      </div>
    </div>

    <div class="foot-button-block">
      <button type="button" class="button button-primary" @click="goToIndexPage">
        トップページに戻る
      </button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittBookingResult",
  setup() {
    const store = useStore();
    const route = useRoute();

    const selectedCoupon = store.getters["MFITT/selectedCoupon"];

    const isSubscription =
      selectedCoupon != null && selectedCoupon.type == "subscription";

    const isUseCoupon = selectedCoupon != null;

    // 予約/購入したチケットの情報
    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );

    // 予約/購入:booking, 変更:change
    const method = route.query.method;

    const goToIndexPage = () => {
      //trigger native when exchange completed for reivew popup
      if (!isNotTargetVersion.value && isSubscription && method == "booking") {
        nativeHandlerService.ncPassPortExchangeCompleted();
      }
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);
    const isNotTargetVersion = ref(false);

    const checkVersion = () => {
      let bool = false;
      switch (device.value) {
        case "IOS":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.2");
          break;
        case "ANDROID":
          bool =
            convertVersionForCompare(appVersion.value) <
            convertVersionForCompare("2.7.2");
          break;
        default:
          bool = false;
          break;
      }
      isNotTargetVersion.value = bool;
    };

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    onMounted(() => {
      nativeHandlerService.ncAppVersion();
    })

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    return {
      myLimitedExpressTicket,
      method,
      isUseCoupon,
      isSubscription,
      goToIndexPage,
    };
  },
};
</script>
<style scoped lang="scss">
.ticket-romancecar h1.heading.center {
  margin: 55px 0 30px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.ticket-romancecar .alert-erea {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 106px;
  margin: 46px 0 26px;
  padding: 0;
  text-align: center;
  color: #ffffff;
  background-color: #e0e0e0;
}

.ticket-romancecar .reserved {
  background-color: #7cb129;
}

.ticket-romancecar .buy {
  background-color: #3a9abe;
}

.ticket-romancecar .reserved::before,
.ticket-romancecar .buy::before {
  position: absolute;
  content: "";
  width: 46px;
  height: 47px;
  top: -23px;
  left: calc(50% - 23px);
  background-repeat: no-repeat;
}

.ticket-romancecar .reserved::before {
  background: url("~@/assets/img/icon/svg/icon-success1.svg");
}

.ticket-romancecar .buy::before {
  background: url("~@/assets/img/icon/svg/icon-success2.svg");
}

.ticket-romancecar .alert-erea .alert {
  align-self: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  margin-top: 23px;
}

.caution-block {
  margin-bottom: 100px;
}

.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}

.foot-button-block button {
  width: calc(100% - 30px);
  height: 46px;
  border: none;
  border-radius: 30px;
  background-color: #e0e0e0;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}

.foot-button-block button:nth-of-type(n + 2) {
  margin-top: 20px;
}

.foot-button-block button.button-primary {
  background-color: #ffb206;
  color: #ffffff;
}

.ticket-romancecar .warning-block {
  margin: 16px 6px 16px;
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  color: #ed2323;
  font-weight: bold;
}
</style>
